import selectFilter from './selectFilter';
import { action } from 'satcheljs/lib/legacy';
import { ActionSource } from 'owa-mail-store';

export default action('clearFilter')(function clearFilter(actionSource: ActionSource) {
    selectFilter('All', actionSource);
});
